<div>
    <h1 mat-dialog-title class="h1-dark fs-20-i fw-500-i">Stop live stream</h1>
    <div mat-dialog-content>
        <div class="pb-10 pt-10">
            <div class="pb-10 pt-10">
                <div class="form-item">
                    <label class="fs-14 fw-400 lh-16 text-0087 d-block ff-roboto">Are you sure that you want to end the stream?</label>
                </div>
            </div>
            <div mat-dialog-actions class="pstn-relative mb-0-i p-0-24-i bt-s1-i bc-00012-i mt-15 m-0-sm d-flex-col-sm jc-ai-start-sm">
                <mat-spinner diameter="25" class="color-primary pstn-absolute t24 l4" [class.hidden]="!inProgress">
                </mat-spinner>
                <button mat-flat-button class="tt-upper text-primary ml-auto-i mr-15-i m-0-sm mt-sm-10 mb-sm-10 w-120px b-s1-i" (click)="onCancelClick()">
                    <span>Not Yet</span>
                </button>
                <button mat-raised-button color="primary" class="tt-upper ml-0-i w-120px" (click)="endStream()">
                    <span>End Stream</span>
                </button>
            </div>
        </div>
    </div>
</div>